// Module
var code = "<template> <section> <iframe id=\"calendarFrame\" aria-label=\"${'core:calendar.$' | t}\" title=\"${'core:calendar.$' | t}\" style=\"width:100%;height:100vh\"></iframe> </section> </template> ";
// Exports
module.exports = code;